import React from "react";
import * as types from "./types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
  switch (action.type) {
    case types.UPDATE_PAGE_VALID:
      return { ...state, ...action.payload };
    default:
      return { ...state };
  }
};
